import React from "react";
import PlusButton from "../buttons/PlusButton";
import WatchButton from "../buttons/WatchButton";

import "./AnimeDesc.scss";

const AnimeDesc = ({ title }) => {
  return (
    <div className="anime-desc">
      <div className="anime-desc__name">{title}</div>
      <div className="anime-desc__user">
        <div className="anime-desc__gener">Drama, Action, Thriller</div>
        <div className="anime-desc__match">94% Match</div>
      </div>
      <div className="anime-desc__buttons">
        <WatchButton />
        <PlusButton />
      </div>
    </div>
  );
};

export default AnimeDesc;
